/**
 * Footer Component
 * Simple footer with copyright
 */
import { Container } from 'react-bootstrap';
import { motion } from 'framer-motion';
import FavoriteIcon from '@mui/icons-material/Favorite';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <Container>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          © {currentYear} Riddhi Patel.
        </motion.p>
      </Container>
    </footer>
  );
};

export default Footer;
